/* eslint-disable @typescript-eslint/ban-types */
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, NgModule, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipeModule } from '@app/core/pipes/pipe.module';
import { TranslateModule } from '@ngx-translate/core';
import { Dropdown, DropdownOptions, InstanceOptions } from 'flowbite';

@Component({
  selector: 'app-system-dropdown-avatar',
  styleUrls: ['./dropdown-avatar.component.scss'],
  templateUrl: './dropdown-avatar.component.html',
})
export class DropdownAvatarComponent implements AfterViewInit, OnChanges {
  @Input() imgAvatar = 'assets/img/avatar-default.svg';
  @Input({ required: true }) name = '';
  @Input({ required: true }) email = '';
  @Input({ required: true }) items: {
    title: string;
    action: Function;
  }[] = [];
  @Input() idDropdown = 'dropdownAvatar';

  options: DropdownOptions = {
    placement: 'bottom',
    triggerType: 'click',
    offsetSkidding: 0,
    offsetDistance: 10,
    delay: 300,
  };

  instanceOptions: InstanceOptions = {
    id: this.idDropdown,
    override: true,
  };

  dropdown!: Dropdown;
  constructor() {}
  @Input() signOut = () => {};

  ngOnChanges(changes: SimpleChanges): void {
    this.imgAvatar = changes?.imgAvatar?.currentValue ?? this.imgAvatar;
    this.name = changes.name?.currentValue ?? this.name;
    this.email = changes.email?.currentValue ?? this.email;
  }

  ngAfterViewInit(): void {
    const $targetElement = document.getElementById(this.idDropdown);
    const $triggerElement = document.getElementById(this.idDropdown + 'Button');
    this.dropdown = new Dropdown($targetElement, $triggerElement, this.options, this.instanceOptions);
  }

  onClickAction(action: Function) {
    action();
    this.dropdown.hide();
  }
}

@NgModule({
  declarations: [DropdownAvatarComponent],
  exports: [DropdownAvatarComponent],
  imports: [RouterModule, CommonModule, TranslateModule, PipeModule],
})
export class SystemDropdownAvatarModule {}
